import React from 'react';
import type { FC } from 'react';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = (props) => {
  return (
    <img
      height={props.height}
      alt='Logo'
      src={props.link}
      {...props}
    />
  );
}

export default Logo;
